<template>
<div class="chapter">
<div class="inner_page">
<p class="dedhead"><a id="pg3"><i>Dedication</i></a></p><a id="pg3">
<p class="ded">To the best family anyone could ask for: Kevin, Zach, Parker, and Abby</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_dedication.vue?58ea182c